export var FacepileStyles = function (props) {
    var theme = props.theme;
    var palette = theme.palette;
    return {
        overflowButton: {
            backgroundColor: palette.neutralLighter,
        },
        descriptiveOverflowButton: {
            backgroundColor: palette.neutralLighter,
        },
    };
};
//# sourceMappingURL=Facepile.styles.js.map